import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";

import LoginBase from "components/LoginBase/LoginBase";

import Button from "components/CustomButtons/CustomButton";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";
import { getDocument } from "../Services/OrdersService";
import { Grid } from "@material-ui/core";

const useStyles = makeStyles(styles);

export default function LoginPage() {
  const routeParams = useParams();
  const dispatch = useDispatch();
  const { type, policyNumber } = routeParams;

  const classes = useStyles();

  useEffect(() => {
    const token = localStorage.getItem("userToken");
    if (token) {
      if (window.location.href.includes("admin/policyPdf")) {
        getDataDocument("view");
      }
    } else {
      window.location.replace("/auth/login-page");
    }
  }, [dispatch]);

  const getDataDocument = async (actionType) => {
    const resultSubmit = await dispatch(
      getDocument({ policyNumber: policyNumber, type: type + "View" })
    );
    if (
      ["errorFileStatus", "errorNoExists"].includes(resultSubmit.payload.data)
    ) {
      window.location.href = "/auth/login";
    } else {
      if (actionType === "download") {
        let a = document.createElement("a");
        a.href = "data:application/pdf;base64," + resultSubmit.payload.data;
        a.download = `${resultSubmit.payload.filename}.pdf`;
        a.click();
      } else {
        const byteCharacters = atob(resultSubmit.payload.data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });
        const blobUrl = URL.createObjectURL(blob);

        window.location.href = blobUrl;
      }
    }
  };

  return (
    <LoginBase>
      <div style={{ marginTop: "10px" }} className={classes.center}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Button
              onClick={() => window.close()}
              style={{ backgroundColor: "#008670" }}
              block
            >
              Back to Home
            </Button>
          </GridItem>
        </GridContainer>
      </div>
    </LoginBase>
  );
}
